import { render, staticRenderFns } from "./Factures.vue?vue&type=template&id=ef08a806&"
import script from "./Factures.vue?vue&type=script&lang=js&"
export * from "./Factures.vue?vue&type=script&lang=js&"
import style0 from "./Factures.vue?vue&type=style&index=0&id=ef08a806&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports